import * as React from 'react';
import NumberFormat from 'react-number-format';

export interface Props {
  val: any;
  decimalScale?: number;
  prefix?: string;
}

const NumberElement = (props: Props) => (
  <NumberFormat
    value={props.val}
    displayType="text"
    thousandSeparator
    prefix={props.prefix}
    decimalScale={props.decimalScale}
  />
);

export default NumberElement;
